module.exports = __webpack_public_path__ + "img/Article page _secondary image.d708d29a.png";